// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard__erXYC"};